"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdentityDataClient = void 0;
class IdentityDataClient {
    constructor(authServiceWeConnectFag, stage) {
        this.authServiceWeConnectFag = authServiceWeConnectFag;
        this.resourceHostId = `myvw-customer-profile-${stage}`;
    }
    async getIdentityData() {
        const response = await this.authServiceWeConnectFag.get(this.resourceHostId, 'v3/customers/__userId__/identityData');
        if (!response.ok) {
            throw new Error();
        }
        return await response.json();
    }
}
exports.IdentityDataClient = IdentityDataClient;
//# sourceMappingURL=IdentityDataClient.js.map